import { render, staticRenderFns } from "./script-list.vue?vue&type=template&id=0b3d11d0&scoped=true&"
import script from "./script-list.vue?vue&type=script&lang=js&"
export * from "./script-list.vue?vue&type=script&lang=js&"
import style0 from "./script-list.vue?vue&type=style&index=0&id=0b3d11d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3d11d0",
  null
  
)

export default component.exports